import type { DesoProtocolConfiguration } from "deso-protocol";
import { configure } from "deso-protocol";

import { APP_NAME } from "@/utils/constants";

export const configureDesoProtocol = (
  options?: Partial<DesoProtocolConfiguration>,
) => {
  configure({
    nodeURI: process.env.NEXT_PUBLIC_NODE_URI,
    identityURI: process.env.NEXT_PUBLIC_IDENTITY_URI,
    network:
      process.env.NEXT_PUBLIC_IS_TESTNET === "true" ? "testnet" : "mainnet",
    spendingLimitOptions: {
      GlobalDESOLimit: 1e9,
      TransactionCountLimitMap: {
        UPDATE_PROFILE: "UNLIMITED",
        SUBMIT_POST: "UNLIMITED",
        NEW_MESSAGE: "UNLIMITED",
        BASIC_TRANSFER: "UNLIMITED",
        FOLLOW: "UNLIMITED",
        LIKE: "UNLIMITED",
        // CREATOR_COIN: "UNLIMITED",
        // CREATOR_COIN_TRANSFER: "UNLIMITED",
        CREATE_USER_ASSOCIATION: "UNLIMITED",
        CREATE_POST_ASSOCIATION: "UNLIMITED",
        ACCESS_GROUP: "UNLIMITED",
        ACCESS_GROUP_MEMBERS: "UNLIMITED",
      },
      CreatorCoinOperationLimitMap: {
        "": { any: "UNLIMITED" },
      },
      AssociationLimitMap: [
        {
          AssociationClass: "Post",
          AssociationType: "",
          AppScopeType: "Any",
          AppPublicKeyBase58Check: "",
          AssociationOperation: "Any",
          OpCount: "UNLIMITED",
        },
        {
          AssociationClass: "User",
          AssociationType: "",
          AppPublicKeyBase58Check: "",
          AppScopeType: "Any",
          AssociationOperation: "Any",
          OpCount: "UNLIMITED",
        },
      ],
      AccessGroupLimitMap: [
        {
          AccessGroupOwnerPublicKeyBase58Check: "",
          ScopeType: "Any",
          AccessGroupKeyName: "",
          OperationType: "Any",
          OpCount: "UNLIMITED",
        },
      ],
      AccessGroupMemberLimitMap: [
        {
          AccessGroupOwnerPublicKeyBase58Check: "",
          ScopeType: "Any",
          AccessGroupKeyName: "",
          OperationType: "Any",
          OpCount: "UNLIMITED",
        },
      ],
    },
    MinFeeRateNanosPerKB: 1000,
    appName: APP_NAME,
    ...options,
  });
};
